"use client"

import { cn } from "@rarible_int/anaconda_ui_components"

interface BluredOverlayProps extends React.ComponentProps<"div"> {
  brandTheme?: {
    backgroundColor: string
    textColor: string
  }
}

export function BluredOverlay({
  className,
  brandTheme,
  style,
  ...props
}: BluredOverlayProps) {
  const brandStyle = brandTheme
    ? {
        backgroundColor: brandTheme.backgroundColor,
        color: brandTheme.textColor,
        ...style,
      }
    : style

  return (
    <div
      className={cn(
        brandTheme
          ? "backdrop-blur-[10px]"
          : "bg-background/95 backdrop-blur-[10px]",
        className,
      )}
      style={brandStyle}
      {...props}
    />
  )
}
